import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import ApiService from "../../_services/ApiService";
import Loader from "./../../_components/loader/loader";
import { Chart } from "chart.js";
import { ReactComponent as PdfIcon } from "./images/file-lines-solid.svg";
import { ReactComponent as TickMark } from "./images/circle-check-solid.svg";
import { ReactComponent as Xmark } from "./images/circle-xmark-solid.svg";
import UserService from "../../_services/UserService";
import Config from "../../_config/config";
import { Modal, Button } from "react-bootstrap";
import "./testResult.styles.css";
import { TestResultContext } from "../../contexts/test-result.context";
import { config } from "mediaelement";
import utils from "../../_helpers/utils";

class TestResult extends Component {
  static contextType = TestResultContext;
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      message: null,
      loading: false,
      studentPdfResponse: false,
      pdfUploadStatus: false,
      result: 0,
      displaying: "barGraphData",
      showModal: false,
      solutionData: null,
      topRankers: {},
      showTopRankers: false,
      solutionCorrectString: "",
      resultUrl: {},
      usingS3: false,
      resultMode3Data: {},
      showApplicationModal: false,
      admitCardDetails: {},
      topperResult: {},
      jeeAplicationPdf: null,
      studentAnswer: null,
      overRideBack: false,
    };
    this.reloadTestResult = this.reloadTestResult.bind(this);
    //this.checkPaperUpload = this.checkPaperUpload.bind(this);
  }
  chartRef = React.createRef();

  async componentDidMount() {
    console.log("top rankers");
    console.log(this.props.match.params.id, "top rankers");

    const { resultUrl } = this.props.location.state || {};

    if (this.props.location.state?.showQuestionWiseAnalysis) {
      console.log("Hello");
      this.requestDataNew();
      // this.getTopRankers();
    } else {
      if (resultUrl) {
        this.setState({ resultUrl });
        const { res } = await this.getResultFromSigned(resultUrl);
        if (res) return;
      }
      this.reloadTestResult();
    }
    localStorage.removeItem("test_id");

    /** compare date validation */
    /*if(this.props.location.state != undefined){
      var testEndDate = this.props.location.state.testEndDate;
      if(testEndDate != "--" && testEndDate !=""){
        testEndDate = testEndDate.substring(0, testEndDate.length - 9);
        console.log(testEndDate);
        var to = this.changeDateFormat(testEndDate,'dd/MM/yy','MM/dd/yy');
        var currentDate = new Date()
        var day = currentDate.getDate()
        var month = currentDate.getMonth() + 1
        var year = currentDate.getFullYear()
        var today = month + "/" + day + "/" + year;
        var from = to + ' 00:00';
        to = today + ' 00:00';
        if(this.isFromBiggerThanTo(from, to)){
          this.setState({
            studentPdfResponse:true
          });
          this.checkPaperUpload();
        }
      }
    }*/
    /** compare date validation */
  }

  getResultFromSigned = async (resultUrl) => {
    const { viewResult } = resultUrl;
    console.log(resultUrl, "result");
    try {
      const res = await ApiService.fetchGetUrl(viewResult);
      console.log(res);
      if (res.data?.message === "Success") {
        this.setState({
          loading: false,
          list: res.data.data,
          result: res.data.result,
          message: res.data.message,
          usingS3: true,
        });

        return { res: true, err: false };
      }

      return { res: false, err: true };
    } catch (err) {
      console.log(err);
      return { res: false, err: true };
    }
  };

  getTopRankers = () => {
    const { list } = this.state;

    if (!list?.summary?.toprankers?.enableStatus) return;

    ApiService.getTopRankers(this.props.match.params.id)
      .then((res) => {
        console.log(res.data, "top rankers");
        this.setState({ topRankers: res.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  componentDidUpdate() {
    let testResult = this.state.list;
    const { resultMode3Data } = this.state;
    if (
      (!testResult?.resultViewerMode || testResult?.resultViewerMode == 1) &&
      this.state.displaying === "barGraphData"
    ) {
      if (testResult.testTakenStatus === "ABSENT") return;

      if (
        Config.siteTitle === "unsat" ||
        Config.siteTitle === "unsat2" ||
        resultMode3Data.resultViewMode === 3
      )
        return;

      if (
        testResult?.testConfig &&
        Number(testResult?.testConfig["result-viewer"]?.mode) === 1 &&
        testResult?.testConfig["result-viewer"]?.showDetails === false
      )
        return;
      this.buildChart();
    }
  }

  externalResultMode3 = async () => {
    const { id } = this.props.match.params;
    try {
      const res = await ApiService.fetchMode3ExternalResult(id);
      console.log(res, "data");
      this.setState({
        loading: false,
        resultMode3Data: res.data,
        result: 1,
        // message: res.data.message,
      });
    } catch (err) {
      console.log(err);
    }
  };

  reloadTestResult = () => {
    let testId = this.props.match.params.id;
    const body = {
      testId,
      userId: UserService.getUserId(),
      tenant: Config.siteTitle,
      enquiryId: UserService.getEnquiryId(),
    };

    this.setState({ loading: true }, () => {
      ApiService.fetchTestResult(body).then(async (res) => {
        console.log(res?.data.resultViewerMode, "data");
        if (res?.data?.resultViewerMode === 3) {
          return this.externalResultMode3();
        }

        if (res.data.resultViewerMode === 2) {
          console.log("top rankers here");
          this.getTopRankers();
        }

        let showApplicationModal = false;

        if (res?.data?.testConfig?.collectAdmitCardDetails?.enabled) {
          const body = {
            tenant: Config.siteTitle,
            userId: UserService.getUserId(),
          };

          try {
            const applicationStatusRes =
              await ApiService.checkJeeAplicationDetails(body);
            const applicationStatus = await applicationStatusRes.json();
            console.log(applicationStatus);
            if (applicationStatus?.res === "success")
              showApplicationModal = false;
            else showApplicationModal = true;
          } catch (err) {
            showApplicationModal = true;
            console.log(err);
          }
        }

        this.setState({
          loading: false,
          list: res.data,
          result: res.result,
          message: res.message,
          displaying: "barGraphData",
          showApplicationModal,
          overRideBack: false,
        });
      });
    });
  };

  checkPaperUpload() {
    var id = this.props.match.params.id;
    this.setState({ loading: true }, () => {
      ApiService.fetchTestPaperUploadStatus(id).then((res) => {
        if (res.data.status == 1) {
          this.setState({
            loading: false,
            url: res.data.url,
            pdfUploadStatus: false,
          });
        } else {
          if (this.state.studentPdfResponse == true) {
            this.setState({
              pdfUploadStatus: true,
            });
          } else {
            this.setState({
              pdfUploadStatus: false,
            });
          }
        }
      });
    });
  }

  routeChange(pathname, state) {
    console.log(pathname, state);
    if (state) {
      console.log("here");
      return this.props.history.push({
        pathname,
        state,
      });
    }
    this.props.history.push(pathname);
  }

  changeDateFormat(value, inputFormat, outputFormat) {
    let outputSplitter = "/";
    let strOutputFormat = outputFormat
      .split(outputSplitter)
      .map((i) => i.toUpperCase());
    if (strOutputFormat.length != 3) {
      strOutputFormat = outputFormat.split("-");
      outputSplitter = "-";
    }

    if (strOutputFormat.length != 3)
      throw new Error("wrong output format splitter :(");

    let date = null;

    if (value instanceof Date) {
      date = {
        ["YYYY"]: value.getUTCFullYear(),
        ["MM"]: value.getMonth() + 1,
        ["DD"]: value.getDate(),
      };
    }

    if (typeof value == "string") {
      let inputSplitter = "/";

      var strInputFormat = inputFormat
        .split(inputSplitter)
        .map((i) => i.toUpperCase());
      if (strInputFormat.length != 3) {
        strInputFormat = inputFormat.split("-");
        inputSplitter = "-";
      }

      if (strInputFormat.length != 3)
        throw new Error("wrong input format splitter :(");

      let dateElements = value.split(inputSplitter);
      if (dateElements.length != 3) throw new Error("wrong value :(");

      date = {
        [strInputFormat[0]]: dateElements[0],
        [strInputFormat[1]]: dateElements[1],
        [strInputFormat[2]]: dateElements[2],
      };
    }

    if (!date) throw new Error("unsupported value type:(");

    let result =
      date[strOutputFormat[0]] +
      outputSplitter +
      date[strOutputFormat[1]] +
      outputSplitter +
      date[strOutputFormat[2]];

    return result;
  }

  isFromBiggerThanTo(dtmfrom, dtmto) {
    return new Date(dtmfrom).getTime() >= new Date(dtmto).getTime();
  }

  closeWindow() {
    window.opener?.location?.reload();
    window.close();
  }

  logout = () => {
    this.props.history.push({
      pathname: "/logout",
      state: { redirectRoute: "/loginwithmobile" },
    });
  };

  render() {
    let portlet = JSON.parse(localStorage.getItem("portlet")) || [];
    var pid = this.props.match.params.pid;
    const { loading } = this.state;
    const { displaying, overRideBack } = this.state;
    if (this.state.result == 1) {
      return (
        <div className="testlist">
          {
            <Container fluid>
              <div
                className={`module-header-step2 ${
                  portlet.class ? portlet.class : "test-list-default-portlet"
                }`}
              >
                <div className="">
                  <div className="back">
                    {Config.siteTitle === "unsat" ||
                    Config.siteTitle === "unsat2" ? (
                      this.state.displaying === "questionWiseAnalysis" ? (
                        <FontAwesomeIcon
                          icon={faArrowLeft}
                          onClick={() =>
                            this.props.history.replace("/testdetails")
                          }
                        />
                      ) : (
                        <div className="logout-wrapper">
                          <span
                            className="test-result-logout"
                            onClick={this.logout}
                          >
                            Logout
                          </span>
                        </div>
                      )
                    ) : pid == 1 || pid === "null" ? (
                      <FontAwesomeIcon
                        icon={faTimesCircle}
                        onClick={() => this.closeWindow()}
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faArrowLeft}
                        onClick={
                          overRideBack
                            ? this.reloadTestResult
                            : this.props.history.goBack
                        }
                      />
                    )}
                  </div>
                  <h4>Test Result {this.state.usingS3 && "*"}</h4>
                </div>
              </div>
              {loading ? <Loader /> : this.renderTestResult()}
            </Container>
          }
        </div>
      );
    } else {
      const isMobile = utils.isMobileDevice();
      let msg = (
        <div dangerouslySetInnerHTML={{ __html: this.state.message }} />
      );
      return (
        <div className="testlist">
          {
            <Container fluid>
              <div
                className={`module-header-step2 ${
                  portlet.class ? portlet.class : "orange-card"
                }`}
              >
                <div className="AnalysisReport">
                  <div className="back">
                    {/* <FontAwesomeIcon icon={ faArrowLeft } onClick={this.props.history.goBack} /> */}
                    {(Config.siteTitle === "unsat" ||
                      Config.siteTitle === "unsat2") &&
                    this.state.resultUrl.detailedProfiling ? (
                      <div className="logout-wrapper">
                        <span
                          className="test-result-logout"
                          onClick={this.logout}
                        >
                          Logout
                        </span>
                      </div>
                    ) : pid == 1 || pid === "null" ? (
                      <FontAwesomeIcon
                        icon={faTimesCircle}
                        onClick={() => this.closeWindow()}
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faArrowLeft}
                        onClick={
                          displaying === "questionWiseAnalysis"
                            ? this.reloadTestResult
                            : this.props.history.goBack
                        }
                      />
                    )}
                  </div>
                  <h4>Online Tests Result</h4>
                </div>
              </div>
              <div className="testResult">
                {this.state.loading ? <Loader /> : msg}
                {this.state.pdfUploadStatus == true && (
                  <button
                    className={`resultbtn ${
                      portlet.class ? portlet.class : "orange-card"
                    }`}
                    onClick={() =>
                      this.routeChange(
                        "/test/upload/" + this.props.match.params.id
                      )
                    }
                  >
                    Upload PDF
                  </button>
                )}
              </div>
              <div className="testgraph" style={{ display: "none" }}>
                <canvas
                  id="myChart"
                  style={{
                    width: "750px !important",
                    height: "750px !important",
                  }}
                  ref={this.chartRef}
                />
              </div>
            </Container>
          }
        </div>
      );
    }
  }

  renderTestResult() {
    let testResult = this.state.list;
    if (testResult.testTakenStatus === "ABSENT") {
      return <span className="absent-text">You were absent for the test.</span>;
    }

    if (
      (testResult?.resultViewerMode && testResult?.resultViewerMode == 2) ||
      this.state.displaying === "questionWiseAnalysis"
    ) {
      return this.renderTestResultView2();
    } else {
      return this.renderTestResultView1();
    }
  }

  sortQuestionWiseAnalysis = (sections) => {
    if (!sections) return [];
    const newSections = sections.map((section) => {
      section.questions = section?.questions?.sort((questOne, questTwo) => {
        console.log(
          parseInt(questOne.questionOrder),
          parseInt(questTwo.questionOrder),
          (parseInt(questOne.questionOrder) || 0) >=
            (parseInt(questTwo.questionOrder) || 0)
        );
        if (
          (parseInt(questOne.questionOrder) || questOne.index) >=
          (parseInt(questTwo.questionOrder) || questTwo.index)
        )
          return 1;
        else return -1;
      });
      console.log(section.questions);
      return section;
    });
    console.log(newSections);
    return newSections;
  };

  fetchToppersData = async (topperDetails) => {
    const { id } = this.props.match.params;
    const body = {
      tenant: Config.siteTitle,
      testId: id,
      userId: topperDetails[0].userId,
      enquiryId: topperDetails[0].enquiryId,
    };
    console.log(body);
    try {
      const topperResult = await ApiService.questionWiseAnalysis(body);
      console.log(topperResult, "here");
      this.setState({ topperResult });
    } catch (err) {
      console.log(err);
    }
  };

  requestDataNew = async () => {
    const { getTestResult } = this.context;
    this.setState({ usingS3: false });
    const { resultUrl } = this.state;
    const { detailedProfiling } = resultUrl || {};
    const id = this.props.match.params.id;

    this.setState({ loading: true, list: [], message: null, result: 0 });
    if (detailedProfiling) {
      try {
        console.log("here success");

        const res = await ApiService.fetchGetUrl(detailedProfiling);
        if (res.data?.message === "Success") {
          let { data } = res.data;
          console.log(data);
          if (data?.summary?.setId > 0) {
            data.sections = this.sortQuestionWiseAnalysis(data?.sections);
          }
          return this.setState(
            {
              loading: false,
              list: data,
              result: res.data.result,
              message: res.data.message,
              displaying: "questionWiseAnalysis",
              usingS3: true,
            },
            () => {
              this.getTopRankers();
            }
          );
        }
      } catch (err) {
        console.log(err);
      }
    }

    try {
      const res = await getTestResult(id);
      console.log(res, "<----here");
      let data = res.data;
      console.log(data);

      if (data?.topperDetails?.length) {
        await this.fetchToppersData(data.topperDetails);
      }

      if (data?.summary?.setId > 0) {
        data.sections = this.sortQuestionWiseAnalysis(data?.sections);
      }
      this.setState(
        {
          loading: false,
          list: data,
          result: res.result,

          message: res.data.message,
          displaying: "questionWiseAnalysis",
        },
        () => {
          this.getTopRankers();
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  openResultPdf = () => {
    let enquiryId = UserService.getEnquiryId();
    let token = UserService.getToken();
    let id = this.props.match.params.id;
    // window.open();
    // https://triangles.edusquares.com/triangles/offlineTestPaper.do?reqCode=viewPaper&testId=178&enquiryId=35076
    window.open(
      `${Config.siteUrl}${Config.siteTitle}/offlineTestPaper.do?reqCode=viewPaper&testId=${id}&enquiryId=${enquiryId}&token=${token}`
    );
  };

  downloadSolution = (type) => {
    console.log(type);
    window.open(this.state.list?.summary[type]);
  };

  openSolution = (question) => {
    console.log(question);
    ApiService.viewSolution(question?.testId, question?.index, question?.id)
      .then((res) => {
        res.data.attemptStatus = question.attemptStatus;
        res.data.studentResponse =
          question.attemptedString || question.textAnswer;
        this.setState(
          {
            solutionData: res.data,
            solutionCorrectString:
              question.questionCategory === 0
                ? ""
                : (question.questionCategory === 5
                    ? `${question.answerRangeStart}-${question.answerRangeEnd}`
                    : question.correctString) || question.textAnswer,
            studentAnswer:
              question.questionCategory === 0
                ? this.removeHtmlTags(question.textAnswer)
                : "",
          },
          () => {
            this.setState({
              showModal: true,
            });
          }
        );
      })
      .catch((err) => {
        this.setState({
          showModal: true,
        });
        console.log(err);
      });
  };

  closeSolution = () => {
    this.setState({
      showModal: false,
      solutionCorrectString: "",
    });
  };

  dateStringToUnix = (date) => {
    if (!date || date === "--") return;
    // require date format is dd/mm/yy hr:min (AM/PM)
    const [dateString, time, meridiemIndicator] = date?.split(" ");

    let finalTime = time;

    if (meridiemIndicator === "PM") {
      finalTime = `${Number(finalTime.split(":")[0]) + 12}:${
        finalTime.split(":")[1]
      }`;
    }

    const splitedDate = dateString.split("/");

    const finalDate = `${splitedDate[1]}-${splitedDate[0]}-${splitedDate[2]}`;

    const udate = new Date(`${finalDate} ${finalTime}`).getTime();
    if (!isNaN(udate)) {
      var unixDate = udate;
    } else {
      //get month
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var month = monthNames[splitedDate[1] - 1];
      var unixDate = new Date(
        `${month} ${splitedDate[0]} ${splitedDate[2]}  ${finalTime}`
      ).getTime();
    }
    return unixDate;
  };

  addDays = (date, days) => {
    if (!date || !days) return null;
    if (date === "--") return null;
    console.log(date, days);
    let newDate = this.dateStringToUnix(date);
    let result = new Date(newDate);
    result.setDate(result.getDate() + days);

    const yyyy = result.getFullYear();
    let mm = result.getMonth() + 1; // Months start at 0!
    let dd = result.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    const formattedToday = dd + "/" + mm + "/" + yyyy;

    return formattedToday;
  };

  renderRanks = () => {
    const { resultMode3Data } = this.state;
    let {
      testRank,
      schoolRank,
      batchRank,
      studentGrade,
      externalResult,
      testName,
    } = resultMode3Data.data || this.state.list?.barGraphData[0] || {};

    let {
      batchRank: batchRankStatus,
      schoolRank: schoolRankStatus,
      testRank: testRankStatus,
    } = this.state.list?.testConfig?.ranking || {};
    // console.log(testRank, schoolRank, batchRank, studentGrade, externalResult);

    if (typeof externalResult === "string") {
      try {
        externalResult = JSON.parse(externalResult);
      } catch (err) {
        console.log(err);
      }
    }

    // let externResultArr = [];

    // if (externalResult && typeof externalResult === "string")
    //   externResultArr = externalResult.split(",");
    //   console.log(externalResult);

    const offlineExpiryDate = this.addDays(
      this.props.location?.state?.testEndDate,
      externalResult?.offlineExpiryInDays
    );

    // const [onlineCode, onlineDisc, offlineCode, offlineDisc] = externResultArr;
    const { mobileNumber: studentCode } = JSON.parse(
      localStorage.getItem("user") || "{}"
    );

    return (
      <>
        <div className="test-result-ranks">
          {testRank && testRankStatus?.enableStatus && (
            <div className="test-result-rank-wrapper">
              <span className="test-result-rank-heading">
                {testRankStatus.displayName}
              </span>
              <span className="test-details-fancy test-details-rank-value">
                {testRank}
              </span>
            </div>
          )}
          {schoolRank && schoolRankStatus?.enableStatus && (
            <div className="test-result-rank-wrapper">
              <span className="test-result-rank-heading">
                {schoolRankStatus.displayName}
              </span>
              <span className="test-details-fancy test-details-rank-value">
                {schoolRank}
              </span>
            </div>
          )}
          {batchRank && batchRankStatus?.enableStatus && (
            <div className="test-result-rank-wrapper">
              <span className="test-result-rank-heading">
                {batchRankStatus?.displayName}
              </span>
              <span className="test-details-fancy test-details-rank-value">
                {batchRank}
              </span>
            </div>
          )}
          {studentGrade && (
            <div className="test-result-rank-wrapper">
              <span className="test-result-rank-heading">Scholarship Code</span>
              <span className="test-details-fancy test-details-rank-value">
                {studentGrade}
              </span>
            </div>
          )}
        </div>

        {!externalResult && resultMode3Data.resultViewMode === 3 && (
          <div className="test-result-rank-wrapper">
            <span className="test-rank-scholarship">
              <span>
                Sorry, You did not qualify for Scholarship in this Test.
                <br />
                We wish you all the best for the next Scholarship Test.
              </span>
            </span>
          </div>
        )}

        {externalResult &&
          (externalResult?.offlineDiscountPercentage !== undefined ||
            externalResult?.onlineDiscountPercentage !== undefined) && (
            <div className="test-result-rank-wrapper">
              <span className="test-rank-scholarship">
                {!externalResult?.onlineDiscountPercentage &&
                !externalResult.offlineDiscountPercentage ? (
                  <>
                    <span>
                      Sorry, You did not qualify for Scholarship in this Test.
                      <br />
                      We wish you all the best for the next Scholarship Test.
                    </span>
                  </>
                ) : (
                  <>
                    <span className="test-rank-bold">Congratulations! 🎉</span>
                    {testName && (
                      <>
                        <br />
                        <span>
                          Based on your performance in the {testName}:
                        </span>
                      </>
                    )}
                    {/* <br /> */}
                    {externalResult?.onlineDiscountPercentage ? (
                      <>
                        <hr />
                        <span
                          className="test-reult-clickable"
                          onClick={() =>
                            (window.location = "https://www.unacademy.com")
                          }
                        >
                          You have won{" "}
                          <span className="test-rank-bold">
                            {externalResult?.onlineDiscountPercentage}%
                            scholarship
                          </span>{" "}
                          on Unacademy Plus / Iconic subscription.
                          {externalResult?.onlineDiscountCode && (
                            <>
                              Use code:{" "}
                              <span className="test-result-fancy test-rank-bold">
                                {externalResult?.onlineDiscountCode}
                              </span>{" "}
                              to claim it.
                            </>
                          )}
                          {!externalResult?.onlineDiscountCode && (
                            <>
                              {" "}
                              You will receive the coupon code to claim this
                              discount on your email in 48 hours.
                            </>
                          )}
                          {externalResult?.onlineExpiryDateString ? (
                            <>
                              {" "}
                              This scholarship is valid till{" "}
                              {externalResult?.onlineExpiryDateString}.
                            </>
                          ):
                          <>
                              {" "}
                              This scholarship is valid till 7 days from scholarship test date.
                            </>
                          }
                        </span>
                      </>
                    ) : null}
                    {externalResult?.offlineDiscountPercentage ? (
                      <span
                        className="test-reult-clickable"
                        onClick={() =>
                          (window.location =
                            "https://unacademy.com/offline/centres")
                        }
                      >
                        <br />
                        <hr />
                        You have won{" "}
                        <span className="test-rank-bold">
                          {externalResult?.offlineDiscountPercentage}%
                          scholarship
                        </span>{" "}
                        on Unacademy Centre subscription.
                        {externalResult?.offlineDiscountCode && (
                          <>
                            {/* Use code: */}
                            Visit your nearest Unacademy centre and show the
                            code{" "}
                            <span className="test-result-fancy test-rank-bold">
                              {externalResult?.offlineDiscountCode}
                            </span>{" "}
                            to claim the scholarship.
                            {/* to claim it. */}
                          </>
                        )}
                        {!externalResult?.offlineDiscountCode && (
                          <>
                            {" "}
                            Please walk into the nearest Unacademy centre and
                            display this message or quote your Learner code:{" "}
                            <span className="test-rank-bold">
                              {studentCode}
                            </span>{" "}
                            to claim this benefit.
                          </>
                        )}
                        {Config.siteTitle === "unsat" ? (
                          externalResult?.onlineExpiryDateString && (
                            <>
                              {" "}
                              This scholarship is valid till{" "}
                              {externalResult?.onlineExpiryDateString}.
                            </>
                          )
                        ) : (
                          <>{" "}This scholarship is valid till {externalResult?.offlineExpiryInDays} days from scholarship test date.</>
                        )}
                      </span>
                    ) : null}
                  </>
                )}
              </span>
              {/* <span className="test-result-rank-heading">Scholarship Code</span> */}
              {/* <span className="test-details-fancy test-details-rank-value"> */}
            </div>
          )}
      </>
    );
  };

  closeApplicationModal = () => {
    this.setState({
      showApplicationModal: false,
    });
  };

  handleApplicationFormSubmit = async (e) => {
    e.preventDefault();
    const { jeeAplicationPdf } = this.state;
    if (jeeAplicationPdf === null) return;

    const { admitCardDetails } = this.state;
    const userDetails = {
      tenant: Config.siteTitle,
      userId: UserService.getUserId(),
      token: UserService.getToken(),
      admitCardDetails,
    };

    const formData = new FormData();
    formData.append("file", jeeAplicationPdf, jeeAplicationPdf?.name);
    formData.append("userDetails", JSON.stringify(userDetails));

    try {
      const res = await ApiService.submitJeeAplicationDetails(formData);
      const applicationSubmitRes = await res.json();
      console.log(applicationSubmitRes);
    } catch (err) {
      console.log(err);
    } finally {
      this.closeApplicationModal();
    }
  };

  handleApplicationFormChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      admitCardDetails: {
        ...prevState.admitCardDetails,
        [name]: value,
      },
    }));
  };

  onFileChange = (event) => {
    this.setState({ jeeAplicationPdf: event.target.files[0] });
  };

  requestQuestionWiseData = () => {
    this.setState({ overRideBack: true });
    this.requestDataNew();
  };

  renderTestResultView1() {
    let data = this.state.list;
    const { resultMode3Data } = this.state;
    let portlet = JSON.parse(localStorage.getItem("portlet")) || [];
    const RenderRanks = this.renderRanks;
    return (
      <>
        <Modal
          className="test-result-application-modal"
          show={this.state.showApplicationModal}
          onHide={
            data?.testConfig?.collectAdmitCardDetails?.mandatory
              ? () => {}
              : this.closeApplicationModal
          }
        >
          <form onSubmit={this.handleApplicationFormSubmit}>
            <Modal.Header
              className="result-application-modal-header"
              closeButton={
                !data?.testConfig?.collectAdmitCardDetails?.mandatory
              }
            >
              <h4> Thank you for taking this All India Test. </h4>
              To view the detailed analysis of your performance, please provide
              us with the following information:
            </Modal.Header>
            <Modal.Body>
              <div className="test-result-application-wrapper">
                <div className="test-result-application-div">
                  <label>Your IIT JEE / NEET Application Number</label>
                  <input
                    type="text"
                    name="admitCardNumber"
                    pattern="^[0-9]{12}$"
                    onChange={this.handleApplicationFormChange}
                    placeholder="12 digit application number"
                    required
                  />
                </div>
                <div className="test-result-application-div">
                  <label>
                    Your Mobile Number (used for JEE/NEET registration)
                  </label>
                  <input
                    type="text"
                    name="mobileNumber"
                    pattern="^[0-9]{10}$"
                    onChange={this.handleApplicationFormChange}
                    placeholder="10 digit mobile number"
                    required
                  />
                </div>
                <div className="test-result-application-div">
                  <label>Your Date of Birth </label>
                  <input
                    type="date"
                    name="dob"
                    onChange={this.handleApplicationFormChange}
                    required
                  />
                </div>
                <div className="has-validation test-result-application-div">
                  <label for="formFile" className="form-label">
                    JEE/NEET Application
                  </label>
                  <input
                    onChange={this.onFileChange}
                    className="form-control"
                    type="file"
                    id="formFile"
                    style={{ padding: "0.2rem 0.75rem" }}
                    required
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="result-application-modal-footer">
              <button className="btn btn-success">Submit</button>
            </Modal.Footer>
          </form>
        </Modal>

        <div className="test-result-logo-container">
          <img
            className="test-result-logo"
            src={`https://webfront.edusquares.com/${Config.siteTitle}/files/logos/logo.png`}
            alt="logo"
          />
        </div>
        {data?.analysisAnnouncement && (
          <div
            dangerouslySetInnerHTML={{ __html: data?.analysisAnnouncement }}
          />
        )}
        {<RenderRanks />}
        {this.renderCard()}
        {data?.testConfig &&
        Number(data?.testConfig["result-viewer"]?.mode) === 1 &&
        data?.testConfig["result-viewer"]?.showDetails === false ? null : (
          <div className="testResult">
            {/* {data.showAnalysisButtons==1 && <button className={`resultbtn ${portlet.class ? portlet.class : 'orange-card'}`}  onClick={() => this.routeChange('/test-result-detail/'+this.props.match.params.id)} >Detailed Profiling</button>} */}
            {data.showAnalysisButtons == 1 && (
              <button
                className={`resultbtn ${
                  portlet.class ? portlet.class : "orange-card"
                }`}
                onClick={() =>
                  this.routeChange(
                    "/detailed-profiling/" + this.props.match.params.id,
                    this.state.resultUrl.detailedProfiling
                      ? { resultUrl: this.state.resultUrl }
                      : null
                  )
                }
              >
                Detailed Profiling
              </button>
            )}
            {/* {data.showAnalysisButtons==1 && <button className={`resultbtn ${portlet.class ? portlet.class : 'orange-card'}`}  onClick={() => this.routeChange('/test-result-question-wise/'+this.props.match.params.id)} >Question Wise Analysis</button>} */}
            {data.showAnalysisButtons == 1 && (
              <button
                className={`resultbtn ${
                  portlet.class ? portlet.class : "orange-card"
                }`}
                onClick={this.requestQuestionWiseData}
              >
                Question Wise Analysis
              </button>
            )}
            {data.showAnalysisButtons == 1 && (
              <button
                className={`resultbtn ${
                  portlet.class ? portlet.class : "orange-card"
                }`}
                onClick={() =>
                  this.routeChange(
                    "/questionpaper/" + this.props.match.params.id,
                    data.dataSource === "offline"
                      ? { testPaperSolution: data.solutionsJson }
                      : null
                  )
                }
              >
                Question paper with solution
              </button>
            )}
          </div>
        )}
        {/* <h4>Your Performance in Test</h4> */}
        {Config.siteTitle === "unsat" ||
        Config.siteTitle === "unsat2" ||
        resultMode3Data.resultViewMode === 3 ? null : data?.testConfig &&
          Number(data?.testConfig["result-viewer"]?.mode) === 1 &&
          data?.testConfig["result-viewer"]?.showDetails === false ? null : (
          <div className="testResult">
            <div className="result_card_list">
              <div className="testgraph">
                <canvas id="myChart" ref={this.chartRef} />
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  displayRank = () => {
    this.setState({ showTopRankers: true });
  };

  closeRanks = () => {
    this.setState({ showTopRankers: false });
  };

  removeHtmlTags = (htmlString) => {
    let doc = new DOMParser().parseFromString(htmlString, "text/html");
    return doc.body.textContent || "";
  };
  renderTestResultView2() {
    let result = this.state.list;
    let user = JSON.parse(localStorage.getItem("user"));
    let portlet = JSON.parse(localStorage.getItem("portlet")) || [];
    const { solutionCorrectString, solutionData } = this.state;
    const correctSolArr = solutionCorrectString?.split(",");
    const studentAnsArr = solutionData?.studentResponse?.split(",");
    console.log(correctSolArr, studentAnsArr);
    return (
      <>
        <div className="testResult">
          <div className="result_card_list">
            <div className="test-name-div">
              <h4>{result.testName}</h4>
              {this.state.topRankers.rankers?.map((data) => {
                if (user.studentCode === data.studentCode) {
                  return (
                    <h6 className="rank-info">
                      {" "}
                      Your Rank is{" "}
                      {`${data.schoolRank}/${this.state.topRankers.rankers?.length}`}
                    </h6>
                  );
                }
                return null;
              })}
            </div>
            {this.state.list?.summary?.toprankers?.enableStatus && (
              <Button onClick={this.displayRank}>Top Rankers</Button>
            )}
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col-md-5">
              <div className="test_summary_card blue-card test-result-mg">
                <h4>Summary</h4>
                <table>
                  <tr>
                    <th className="text-center summary-box">Total Questions</th>
                    <th className="text-center summary-box">Total Marks</th>
                    <th className="text-center summary-box">Your Score</th>
                  </tr>
                  <tr>
                    <td className="text-center">
                      {result?.summary?.numberOfQuestions}
                    </td>
                    <td className="text-center">
                      {result?.summary?.totalMarks}
                    </td>
                    <td className="text-center">
                      <span style={{ fontWeight: "bolder" }}>
                        {result?.summary?.marksObtained}
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div className="col-md-5">
              <div className="test_summary_card blue-card test-result-mg">
                <h4>Attempt Summary</h4>
                <table>
                  <tr>
                    <th className="text-center summary-box">Correct</th>
                    <th className="text-center summary-box">Wrong</th>
                    <th className="text-center summary-box">Unattempted</th>
                  </tr>
                  <tr>
                    <td className="text-center">
                      {result.summary?.correctQuestions}
                    </td>
                    <td className="text-center">
                      {result.summary?.wrongQuestions}
                    </td>
                    <td className="text-center">
                      {result.summary?.unattemptedQuestions}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <br />
          <br />
          {result.sections &&
            result.sections.map((section, index) => {
              return (
                <>
                  {this.state.list?.summary?.solutions && (
                    <span
                      className="view-solution"
                      onClick={() => this.downloadSolution("solutions")}
                    >
                      Download - Solutions{" "}
                    </span>
                  )}
                  {this.state.list?.summary?.testPaper && (
                    <span
                      className="view-solution"
                      onClick={() => this.downloadSolution("testPaper")}
                    >
                      {" "}
                      || Download - Test Paper{" "}
                    </span>
                  )}
                  {this.state.list?.summary?.testPaperWithSolutions && (
                    <span
                      className="view-solution"
                      onClick={() =>
                        this.downloadSolution("testPaperWithSolutions")
                      }
                    >
                      {" "}
                      || Download - Test Paper With Solution{" "}
                    </span>
                  )}
                  {this.state.list.needsManualEvaluation && (
                    <span
                      className="view-solution"
                      onClick={this.openResultPdf}
                    >
                      {" "}
                      || Your Answer Script
                    </span>
                  )}
                  <div className="row">
                    <div className="col">
                      <div
                        style={{ overflowY: "scroll" }}
                        className="test_summary_card blue-card"
                      >
                        <h4>
                          {section.sectionName} /{" "}
                          {this.state.list?.summary?.setName}
                        </h4>
                        <table>
                          <tr>
                            <th className="text-center">#</th>
                            {result.tagTypes &&
                              result.tagTypes.map((tagType, tagTypeIndex) => {
                                return (
                                  <>
                                    <th className="text-center">
                                      {tagType.name}
                                    </th>
                                  </>
                                );
                              })}
                            {/* <th className="text-center">Set</th> */}
                            <th className="text-center">Attempt Time</th>
                            {this.state.topperResult.data && (
                              <th className="text-center">
                                Topper Attempt Time
                              </th>
                            )}
                            <th className="text-center">Your Response</th>
                            {this.state.topperResult.data && (
                              <th className="text-center">Topper Response</th>
                            )}
                            <th className="text-center">Correct Answer</th>
                            <th className="text-center">Score</th>
                            {result?.testConfig &&
                            Number(
                              result?.testConfig["result-viewer"]?.mode
                            ) === 2 &&
                            result?.testConfig["result-viewer"]?.showDetails ===
                              false ? null : (
                              <th className="text-center">
                                View{" "}
                                {this.state.list.needsManualEvaluation && (
                                  <PdfIcon
                                    onClick={this.openResultPdf}
                                    className="pdf-icon"
                                  />
                                )}
                              </th>
                            )}
                          </tr>
                          {section.questions &&
                            section.questions.map((question, questionIndex) => {
                              return (
                                <>
                                  <tr>
                                    <td className="text-center">
                                      {question.questionOrder || question.index}
                                    </td>
                                    {question.tags &&
                                      question.tags.map(
                                        (
                                          questioTagType,
                                          questioTagTypesIndex
                                        ) => {
                                          return (
                                            <>
                                              <td className="text-center">
                                                {questioTagType.tags &&
                                                  questioTagType.tags.map(
                                                    (
                                                      questionTag,
                                                      questionTagsIndex
                                                    ) => {
                                                      return (
                                                        <>
                                                          <span className="text-center">
                                                            {questionTag.name}
                                                          </span>
                                                        </>
                                                      );
                                                    }
                                                  )}
                                              </td>
                                            </>
                                          );
                                        }
                                      )}
                                    {/* <td className="text-center">
                                      {this.state.list?.summary?.setName}
                                    </td> */}
                                    <td className="text-center clock-font">
                                      {question.attemptTime} SEC
                                    </td>
                                    {this.state.topperResult.data && (
                                      <td className="text-center clock-font">
                                        {
                                          this.state.topperResult.data.sections[
                                            index
                                          ]?.questions[questionIndex]
                                            ?.attemptTime
                                        }{" "}
                                        SEC
                                      </td>
                                    )}

                                    <td className="text-center">
                                      {question.attemptedString ? (
                                        question.attemptedString
                                      ) : question.textAnswer ? (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: question.textAnswer,
                                          }}
                                        />
                                      ) : (
                                        "--"
                                      )}
                                    </td>
                                    {this.state.topperResult.data && (
                                      <td className="text-center">
                                        {this.state.topperResult.data.sections[
                                          index
                                        ]?.questions[questionIndex]
                                          ?.attemptedString ? (
                                          this.state.topperResult.data.sections[
                                            index
                                          ]?.questions[questionIndex]
                                            ?.attemptedString
                                        ) : this.state.topperResult.data
                                            .sections[index]?.questions[
                                            questionIndex
                                          ]?.textAnswer ? (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                this.state.topperResult.data
                                                  .sections[index]?.questions[
                                                  questionIndex
                                                ]?.textAnswer,
                                            }}
                                          />
                                        ) : (
                                          "--"
                                        )}
                                      </td>
                                    )}
                                    <td className="text-center">
                                      {Number(question.bonusMarks) === 1 &&
                                      question.attemptStatus === 1 ? (
                                        <span>Bonus</span>
                                      ) : question.questionCategory === 0 ? (
                                        ""
                                      ) : (
                                        (question.questionCategory === 5
                                          ? `${question.answerRangeStart}-${question.answerRangeEnd}`
                                          : question.correctString) ||
                                        question.textAnswer
                                      )}
                                    </td>
                                    <td className="text-center">
                                      {question.attemptStatus === -1 ? (
                                        <>
                                          <i className="test-result-unattempted">
                                            --{" "}
                                            <span className="test-result-legend test-result-left-legend">
                                              Unattempted
                                            </span>
                                          </i>
                                        </>
                                      ) : (
                                        <>
                                          {question.marks}/
                                          {parseFloat(question.actualMarks)}
                                        </>
                                      )}
                                    </td>
                                    {result?.testConfig &&
                                    Number(
                                      result.testConfig["result-viewer"]?.mode
                                    ) === 2 &&
                                    result.testConfig["result-viewer"]
                                      ?.showDetails === false ? null : (
                                      <td className="text-center">
                                        <button
                                          onClick={() =>
                                            this.openSolution(question)
                                          }
                                          className={
                                            "download " +
                                            (question.attemptStatus == 1
                                              ? " green-card"
                                              : question.attemptStatus == -1
                                              ? " blue-card"
                                              : " orange-card")
                                          }
                                        >
                                          Solution
                                        </button>
                                      </td>
                                    )}
                                  </tr>
                                </>
                              );
                            })}
                        </table>
                      </div>
                    </div>
                  </div>
                  <br />
                </>
              );
            })}
          <button
            className={`resultbtn ${
              portlet.class ? portlet.class : "orange-card"
            }`}
            onClick={() =>
              this.routeChange(
                "/detailed-profiling/" + this.props.match.params.id,
                this.state.resultUrl.detailedProfiling
                  ? { resultUrl: this.state.resultUrl }
                  : null
              )
            }
          >
            Detailed Profiling
          </button>
        </div>
        <Modal show={this.state.showModal} onHide={this.closeSolution}>
          <Modal.Header className="text-uppercase" closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.solutionData ? (
              <>
                <h4>Question: </h4>
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.state.solutionData?.questionStatement,
                  }}
                ></div>
                {this.state.solutionData?.choiceGroup1.map((choice, i) => (
                  <div>
                    <span className="solution-choice-string">
                      {choice.choiceString}
                    </span>
                    <div
                      className="solution-choice"
                      key={i}
                      dangerouslySetInnerHTML={{ __html: choice.choiceValue }}
                    ></div>
                    {studentAnsArr?.some(
                      (studAns) => studAns === choice.choiceString
                    ) &&
                    correctSolArr?.some(
                      (corrSoln) => corrSoln === choice.choiceString
                    ) ? (
                      <TickMark className="success-option" />
                    ) : (
                      <>
                        {studentAnsArr?.some(
                          (studAns) => studAns === choice.choiceString
                        ) ? (
                          <Xmark className="wrong-option" />
                        ) : null}
                        {correctSolArr?.some(
                          (corrSoln) => corrSoln === choice.choiceString
                        ) ? (
                          <TickMark className="correct-option" />
                        ) : null}
                      </>
                    )}
                  </div>
                ))}
                <div
                  className="answer-box"
                  style={{
                    color: `var(${
                      this.state.solutionData?.attemptStatus === 1
                        ? "--success"
                        : "--danger"
                    })`,
                  }}
                >
                  <span>Correct Answer : </span>{" "}
                  <span>
                    {this.removeHtmlTags(this.state.solutionCorrectString)}
                  </span>{" "}
                  | <span>My Answer : </span>{" "}
                  <span>
                    {this.state.solutionData?.studentResponse ||
                      this.state.studentAnswer}
                  </span>
                </div>
                <h4>Solution: </h4>
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.state.solutionData?.solution,
                  }}
                ></div>
              </>
            ) : (
              <h5>Data is not uploaded</h5>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger"
              className="text-uppercase"
              onClick={this.closeSolution}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size="xl"
          show={this.state.showTopRankers}
          onHide={this.closeRanks}
        >
          <Modal.Header className="text-uppercase" closeButton>
            <Modal.Title>
              <h3>Top Ranks</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.topRankers.rankers?.length ? (
              <div className="rank-wrapper">
                <div className="rank-div rank-heading">
                  {this.state.list?.summary?.toprankers?.columns?.map(
                    (column) => (
                      <div className="rank-details">
                        <h5>{column?.DisplayLabel}</h5>
                      </div>
                    )
                  )}
                </div>
                {this.state.topRankers?.rankers.map((data) => (
                  <div className="rank-div">
                    {this.state.list?.summary?.toprankers?.columns?.map(
                      (column) => (
                        <div className="rank-details">
                          <h6>{data[column.property]}</h6>
                        </div>
                      )
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <h1>No data Found</h1>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger"
              className="text-uppercase"
              onClick={this.closeRanks}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  renderCard() {
    let data = this.state.list;
    const { resultMode3Data } = this.state;
    if (resultMode3Data.resultViewMode === 3) return;
    if (typeof data !== "undefined" || data != null) {
      return (
        <div className="testResult">
          <div className="result_card_list">
            {/* <h4>Your Performance in Test</h4> */}
            <table>
              <tr className="blue-card">
                <th>Section</th>
                <th>Marks</th>
                <th>Max</th>
                <th>%</th>
                {/* {Config.siteTitle === "unsat" ||
                  this.siteTitle === "unsat2" ? null : (
                  <>
                    <th>
                      CH{" "}
                      <i className="test-result-info">
                        i{" "}
                        <span className="test-result-legend test-result-right-legend">
                          Course Highest
                        </span>
                      </i>
                    </th>
                    <th>
                      CA{" "}
                      <i className="test-result-info">
                        i{" "}
                        <span className="test-result-legend test-result-left-legend">
                          Course Average
                        </span>
                      </i>
                    </th>
                  </>
                )} */}
              </tr>
              {data.testTableData &&
                data.testTableData
                  .sort((a, b) => a.sortOrder - b.sortOrder)
                  .map((item, index) => {
                    if (item.sortOrder == 100) {
                      item.sectionName = "Test Total";
                    }
                    return (
                      <tr>
                        <td>
                          <b>{item.sectionName}</b>
                        </td>
                        <td>{item.marks}</td>
                        <td>{item.totalmarks}</td>
                        <td>{item.percentage.toFixed(2)}</td>
                        {/* {Config.siteTitle === "unsat" ||
                          this.siteTitle === "unsat2" ? null : (
                          <>
                            {" "}
                            <td>{item.testHighestPercentage}</td>
                            <td>{item.testAveragePercentage}</td>{" "}
                          </>
                        )} */}
                      </tr>
                    );
                  })}
            </table>
          </div>
          <br />
          {/* {this.renderLegends()} */}
        </div>
      );
    }
  }

  renderLegends() {
    return (
      <div className="result_card_list">
        {/* <h4>Legends</h4> */}
        <table>
          {/* <tr>
            <td>
              <b>Sec</b>
            </td>
            <td>Section</td>
          </tr> */}
          {/* <tr>
            <td>
              <b>Max</b>
            </td>
            <td>Maximum Marks</td>
          </tr> */}
          {/* <tr>
            <td>
              <b>%</b>
            </td>
            <td>Percentage</td>
          </tr> */}
          <tr>
            <td>
              <b>CH</b>
            </td>
            <td>Course Highest</td>
          </tr>
          <tr>
            <td>
              <b>CA</b>
            </td>
            <td>Course Average</td>
          </tr>
        </table>
      </div>
    );
  }

  buildChart = () => {
    const isMobile = utils.isMobileDevice();

    let t1 = {};
    t1.label = "Marks";
    t1.data = [];
    t1.backgroundColor = [];
    t1.borderColor = [];
    t1.borderWidth = 1;

    let t2 = {};
    t2.label = "Topper";
    t2.data = [];
    t2.backgroundColor = [];
    t2.borderColor = [];
    t2.borderWidth = 1;

    let t3 = {};
    t3.label = "Total";
    t3.data = [];
    t3.backgroundColor = [];
    t3.borderColor = [];
    t3.borderWidth = 1;
    let labels = [];
    let barChartData = {};
    let data = this.state.list;
    if (typeof data !== "undefined" || data != null) {
      data.barGraphData &&
        data.barGraphData.map((item, index) => {
          if (index == 0) {
            item.name = "Test";
          }
          labels.push(item.name);

          t1.data.push(item.percentage);
          t1.backgroundColor.push("rgba(0, 128 ,0, 0.8)");
          t1.borderColor.push("rgba(0, 128 ,0, 1)");

          t2.data.push((item.toppermarks / item.totalmarks) * 100);
          t2.backgroundColor.push("rgba(255, 0, 0, 0.8)");
          t2.borderColor.push("rgba(255, 0, 0, 1)");

          t3.data.push(100 /*item.totalmarks*/);
          t3.backgroundColor.push("rgba(31, 119, 180, 0.8)");
          t3.borderColor.push("rgba(31, 119, 180, 1)");
        });

      barChartData = {
        labels: labels,
        datasets: [t1, t2, t3],
      };

      const myChartRef = this.chartRef.current?.getContext("2d");
      myChartRef.height = 700;
      new Chart(myChartRef, {
        type: "bar",
        data: barChartData,
        options: {
          legend: {
            display: true,
            position: "bottom",
            labels: {
              fontColor: "#000080",
            },
          },
          scales: {
            yAxes: [
              {
                display: true,
                ticks: {
                  beginAtZero: true,
                  min: 0,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: isMobile,
        },
      });
    }
  };
}

export default TestResult;
